export default "__VITE_ASSET__CE64g5Vb__"